// extracted by mini-css-extract-plugin
export default {"root":"root--a9SsK","title":"title--Wn_u1"};